import React from "react";

export function Card({ children, className = "", glow = false, ...rest }) {
  return (
    <div className={`card ${glow ? "card-glow" : ""} ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function StatCard({ label, value, sub, icon, color }) {
  return (
    <div className="stat-card">
      {icon && <div className="stat-card-icon">{icon}</div>}
      <div className="stat-card-label">{label}</div>
      <div className="stat-card-value" style={color ? { color } : undefined}>
        {value}
      </div>
      {sub && <div className="stat-card-sub">{sub}</div>}
    </div>
  );
}

export default Card;
